import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/DeletePackage.graphql';
import { Mutation, MutationdeletePackageArgs } from '../../__generated__/globalTypes';

export const useDeletePackageMutation = (options?: MutationHookOptions<Mutation, MutationdeletePackageArgs>) => {
  const [callDeletePackage, result] = useMutation<Mutation, MutationdeletePackageArgs>(MUTATION, options);

  return { callDeletePackage, ...result };
};

export type DeletePackageMutationFunction = Mutation['deletePackage'];
